import React from 'react';
import EnrolledCourses from '../EnrolledCourses/EnrolledCourses'

const profileEnrolledCourses = () => {
  return (
    <div className="section-content-courses">
       <EnrolledCourses />  
    </div>
  );
};

export default profileEnrolledCourses;
